import React from "react";
import "./Internship.css";
import { Link } from "react-router-dom";

const Internship = () => {
  return (
    <div className="internship-page">

      <section className="internship-section">
        <div className="internship-header">

          <div className="text-content">
            <h1 className="main-heading">
              Internship & Skill Development Program (Java | Python | .NET)
            </h1>

            <p className="sub-text">
              Work on real-time projects, build production-ready applications and
              gain hands-on industry experience in Java, Python and .NET.
            </p>

            <p className="sub-text">
              LogicSphere Technologies Pvt.Ltd is an industry-oriented IT
              training and development organization focused on practical learning,
              R&D and real-time project experience.
            </p>

            <p className="sub-text">
              Our programs are designed to teach how software is actually built
              in IT companies through hands-on projects and mentor-guided development.
            </p>
          </div>

          <div className="image-content">
            <img
              src={process.env.PUBLIC_URL + "/Internship.jpg"}
              alt="Internship Program"
              className="internship-image"
            />
          </div>

        </div>
      </section>

      <section className="offer-section">
        <h2 className="section-heading center-heading">What We Offer</h2>

        <div className="offer-grid">
          <div className="offer-card">
            <h3>Java Backend Development</h3>
            <p>Core Java, OOPs Concepts, REST APIs, Spring Boot Basics, Database Integration</p>
          </div>

          <div className="offer-card">
            <h3>Python Development</h3>
            <p>Core Python, OOPs, APIs, Real-World Use Cases</p>
          </div>

          <div className="offer-card">
            <h3>.NET Development</h3>
            <p>C#, ASP.NET Core, Web APIs, Database Connectivity</p>
          </div>

          <div className="offer-card">
            <h3>Industry Tools & Practices</h3>
            <p>SQL, Git & GitHub, Debugging, Code Reviews</p>
          </div>
        </div>
      </section>

      <section className="steps-section">
        <h2 className="section-heading center-heading">Steps Into The IT Industry</h2>

        <div className="steps-grid">
          <div className="step-card">
            <h3>Enroll Online</h3>
            <p>Register & connect with mentors</p>
          </div>

          <div className="step-card">
            <h3>Choose Technology</h3>
            <p>Java | Python | .NET</p>
          </div>

          <div className="step-card">
            <h3>Work on Projects</h3>
            <p>Build real applications</p>
          </div>

          <div className="step-card">
            <h3>Internship Experience</h3>
            <p>Gain industry exposure</p>
          </div>

          <div className="step-card">
            <h3>Join Now</h3>
            <p>Start your career</p>
          </div>
        </div>

        {/* ONLY THIS SECTION UPDATED */}
        <div className="apply-now-container">
          <Link to="/internshipform" className="apply-now-button">
            Apply Now
          </Link>

          <a
            href={process.env.PUBLIC_URL + "/Logicsphere.pdf"}
            download
            className="apply-now-button"
          >
            Download Brochure
          </a>
        </div>

      </section>

      <section className="career-section">
        <h2>Ready to Start Your Career?</h2>
        <p>
          Join LogicSphere Technology Private Limited and begin your journey
          toward becoming an industry-ready professional.
        </p>

        <a
          href="https://logicspheretechnologies.com/"
          target="_blank"
          rel="noreferrer"
        >
          www.logicspheretechnologies.com
        </a>
      </section>

    </div>
  );
};

export default Internship;